<template>
  <div>
    <div>
      <span>Displaying {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} items</span>
      <div class="is-pulled-right">Show
        <select v-model="perPage" v-on:change="showPerPage">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
          <option value="300">300</option>
          <option value="400">400</option>
          <option value="500">500</option>
        </select>
      </div>
    </div>
    <div>
      <nav>
        <ul class="pagination">
          <li>
            <a class="button" href="#" @click="nextPrev($event, pagination.current_page - 1)" :class="[pagination.current_page === 1 ? 'is-disabled' : '']"><span>«</span></a>
          </li>
          <li v-for="page in pages">
            <span v-if="page === '...'" class="button">{{page}}</span>
            <a v-if="page !== '...'" class="button" href="#" @click="navigate($event, page)" :class="[pagination.current_page === page ? 'is-active is-primary' : '']">{{page}}</a>
          </li>
          <li>
            <a class="button" href="#" @click="nextPrev($event, pagination.current_page + 1)" :class="[pagination.current_page === pagination.last_page ? 'is-disabled' : '']"><span>»</span></a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default{
    data () {
      return {
        pages: [],
        perPage: 10
      }
    },
    props: {
      pagination: {
        type: Object,
        required: true
      }
    },
    watch: {
      pagination () {
        this.pages = this.generatePagesArray(this.pagination.current_page, this.pagination.total, this.pagination.per_page, 10)
        this.perPage = this.pagination.per_page
      }
    },
    methods: {
      navigate (event, page) {
        event.preventDefault()
        this.$parent.navigate(page)
      },
      nextPrev (event, page) {
        if (page === 0 || page === this.pagination.last_page + 1) {
          return
        }
        event.preventDefault()
        this.$parent.navigate(page)
      },
      generatePagesArray (currentPage, collectionLength, rowsPerPage, paginationRange) {
        let pages = []
        let totalPages = Math.ceil(collectionLength / rowsPerPage)
        let halfWay = Math.ceil(paginationRange / 2)
        let position

        if (currentPage <= halfWay) {
          position = 'start'
        } else if (totalPages - halfWay < currentPage) {
          position = 'end'
        } else {
          position = 'middle'
        }

        let ellipsesNeeded = paginationRange < totalPages
        let i = 1
        while (i <= totalPages && i <= paginationRange) {
          let pageNumber = this.calculatePageNumber(i, currentPage, paginationRange, totalPages)
          let openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'))
          let closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'))
          if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
            pages.push('...')
          } else {
            pages.push(pageNumber)
          }
          i++
        }
        return pages
      },

      calculatePageNumber (i, currentPage, paginationRange, totalPages) {
        let halfWay = Math.ceil(paginationRange / 2)
        if (i === paginationRange) {
          return totalPages
        } else if (i === 1) {
          return i
        } else if (paginationRange < totalPages) {
          if (totalPages - halfWay < currentPage) {
            return totalPages - paginationRange + i
          } else if (halfWay < currentPage) {
            return currentPage - halfWay + i
          } else {
            return i
          }
        } else {
          return i
        }
      },
      showPerPage () {
        if (this.perPage !== this.pagination.perPage) {
          this.$parent.showPerPage(this.perPage)
        }
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// HyperTablePagination.vue?46938e4c